<template>
  <DialogHeader>
    <template #right>
      <div
        v-if="!loading"
        class="font-medium text-green-900 cursor-pointer"
        @click="handleSubmit"
      >
        Save
      </div>
      <Icon
        v-else
        name="Loading"
        :size="14"
        class="stroke-gray-800 animate-spin"
      />
    </template>
    Change your bio
  </DialogHeader>
  <DialogContent>
    <UiTextarea v-model="bio" label="Bio" />
  </DialogContent>
  <DialogFooter>
    <UiButton
      class="w-1/2 tablet-h:w-auto mr-2.5 tablet-h:mr-2"
      @click="close()"
    >
      Cancel
    </UiButton>
    <UiButton
      class="w-1/2 tablet-h:w-auto"
      primary
      :loading="loading"
      @click="handleSubmit"
    >
      Change bio
    </UiButton>
  </DialogFooter>
</template>

<script setup lang="ts">
import { UiButton, UiTextarea, Icon } from '@dacr/ui'
import DialogHeader from '@/shared/dialogs/DialogHeader.vue'
import DialogContent from '@/shared/dialogs/DialogContent.vue'
import DialogFooter from '@/shared/dialogs/DialogFooter.vue'
import { useDialog } from '@/shared/dialogs/useDialog'
import { ref } from 'vue'
import {
  useUpdateAccountBioMutation,
  type User,
} from '@/shared/graphql/legacy/generated'
import { ToastType, useToastStore } from '@/shared/stores/toast'
import { NativeActionsEnum, useWebviewStore } from '@/shared/stores/webview'

const { close } = useDialog()
const toastStore = useToastStore()
const webviewStore = useWebviewStore()

const props = defineProps<{
  user: User
}>()

const { mutate: updateAccountBio, loading } = useUpdateAccountBioMutation()

const bio = ref(props.user?.bio || '')

const handleSubmit = async () => {
  updateAccountBio(
    {
      bio: bio.value,
    },
    {
      optimisticResponse: {
        __typename: 'Mutation',
        updateAccountBio: {
          __typename: 'User',
          id: props.user.id,
          bio: bio.value,
        },
      },
      update() {
        if (webviewStore.isActive) {
          webviewStore.postMessage({
            type: NativeActionsEnum.UserUpdated,
            data: {
              user: {
                ...props.user,
                bio: bio.value,
              },
            },
          })
        }
      },
    }
  )

  toastStore.showToast({
    type: ToastType.Success,
    content: 'Your bio has updated',
  })

  close()
}
</script>
